(function () {
  "use strict";

  async function includeSections() {
    var includeNodes = Array.prototype.slice.call(document.querySelectorAll("[data-include]"));
    if (!includeNodes.length) {
      return;
    }

    await Promise.all(
      includeNodes.map(async function (node) {
        var source = node.getAttribute("data-include");
        if (!source) {
          return;
        }

        try {
          var response = await fetch(source, { credentials: "same-origin" });
          if (!response.ok) {
            throw new Error("Include fetch failed: " + source);
          }
          node.outerHTML = await response.text();
        } catch (error) {
          node.outerHTML = "";
          console.error(error);
        }
      })
    );

    if (document.querySelector("[data-include]")) {
      await includeSections();
    }
  }

  function initScrollReveal() {
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var revealElements = document.querySelectorAll(".scroll-reveal");

    if (prefersReducedMotion) {
      revealElements.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    if (revealElements.length && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
      );

      revealElements.forEach(function (el) {
        observer.observe(el);
      });
      return;
    }

    revealElements.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  function initSiteNav() {
    var header = document.getElementById("site-header");
    if (!header) {
      return;
    }

    var toggle = header.querySelector("[data-nav-toggle]");
    var nav = header.querySelector("[data-nav]");
    var navLinks = nav
      ? Array.prototype.slice.call(nav.querySelectorAll('.site-nav__link[href^="#"]'))
      : [];

    function setOpen(isOpen) {
      header.classList.toggle("is-open", isOpen);
      if (toggle) {
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }
    }

    function setActiveSection(sectionId) {
      navLinks.forEach(function (link) {
        var isActive = sectionId && link.getAttribute("href") === "#" + sectionId;
        link.classList.toggle("is-active", isActive);
        if (isActive) {
          link.setAttribute("aria-current", "true");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        setOpen(!header.classList.contains("is-open"));
      });
    }

    if (nav) {
      nav.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          setOpen(false);
        });
      });
    }

    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
      if (window.scrollY < 80) {
        setActiveSection("top");
      }
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    window.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });

    var sectionIds = navLinks
      .map(function (link) {
        return link.getAttribute("href").slice(1);
      })
      .filter(function (id) {
        return id && id !== "top";
      });

    var sections = sectionIds
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (!sections.length || !("IntersectionObserver" in window)) {
      return;
    }

    var visibleSections = new Map();

    var spyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visibleSections.set(entry.target.id, entry.intersectionRatio);
          } else {
            visibleSections.delete(entry.target.id);
          }
        });

        if (window.scrollY < 80) {
          setActiveSection("top");
          return;
        }

        var activeId = null;
        var bestRatio = 0;

        visibleSections.forEach(function (ratio, id) {
          if (ratio >= bestRatio) {
            bestRatio = ratio;
            activeId = id;
          }
        });

        setActiveSection(activeId || "top");
      },
      {
        root: null,
        rootMargin: "-20% 0px -55% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    sections.forEach(function (section) {
      spyObserver.observe(section);
    });
  }

  function initFaq() {
    var faq = document.querySelector(".faq");
    if (!faq) {
      return;
    }

    faq.addEventListener("toggle", function (event) {
      var target = event.target;
      if (!target || target.tagName !== "DETAILS" || !target.open) {
        return;
      }

      faq.querySelectorAll("details.faq__item[open]").forEach(function (item) {
        if (item !== target) {
          item.open = false;
        }
      });
    }, true);
  }

  document.addEventListener("DOMContentLoaded", async function () {
    await includeSections();
    initSiteNav();
    initFaq();
    initScrollReveal();
  });
})();
